import * as React from 'react';

import TargetByStudentIdUploadPageContainer from './TargetByStudentIdUploadPageContainer';
import TargetByStudentIdUploadPageBody from './TargetByStudentIdUploadPageBody';

type Props = {
  onUploadSuccess: (data: { studentIdListUuid: string; csvName: string }) => void;
  onOrgSelection: (organizationUuid: string) => void;
  selectedOrganizationUuid: string;
  onMount: () => void;
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ComposerOrganization'.
  organizations: Partial<ComposerOrganization>[] | undefined | null;
};

export default class TargetByStudentIdUploadPage extends React.Component<Props, any> {
  componentDidMount() {
    this.props.onMount();
  }

  render() {
    return (
      <TargetByStudentIdUploadPageContainer
        onUploadSuccess={this.props.onUploadSuccess}
        selectedOrganizationUuid={this.props.selectedOrganizationUuid}
      >
        {(props) => (
          <TargetByStudentIdUploadPageBody
            {...props}
            organizations={this.props.organizations}
            selectedOrganizationUuid={this.props.selectedOrganizationUuid}
            onOrgSelection={this.props.onOrgSelection}
          />
        )}
      </TargetByStudentIdUploadPageContainer>
    );
  }
}
